// src/services/apiClient.js
import axios from 'axios';
import { getBackendUrl } from '../config/config.js';
import { getSafeToken } from '../utils/tokenHelper';

const apiClient = axios.create({
  baseURL: `${getBackendUrl()}/api`,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor para agregar el token JWT automáticamente
apiClient.interceptors.request.use(
  (config) => {
    const token = getSafeToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejo de errores en producción
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // En producción, simplemente rechaza el error para manejo normal
    return Promise.reject(error);
  }
);

export default apiClient;
